<template>
  <div id="app">
    <main-header></main-header>

    <div class="container">
      <router-view/>
    </div>

    <main-footer></main-footer>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    'main-header': Header,
    'main-footer': Footer
  }
}
</script>

<style lang="scss">
@import "./src/util";

body {
  background: #000;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/App.vue